import $ from 'jquery'
import { Postmark } from './application'
import { domready } from './domready'
import invariant from 'ts-invariant'
import { hideElement, showElement } from './visibility-toggles'

function createToken(this: HTMLButtonElement, event: MouseEvent): void {
  event.preventDefault()

  if (
    !confirm(
      'Are you sure you want to generate another token? Your existing tokens will remain active.'
    )
  ) {
    return
  }

  this.classList.add('is-loading')

  const url = this.dataset.url
  invariant(typeof url === 'string')

  $.post(url, html => {
    document
      .querySelector('.js-token-list')
      ?.insertAdjacentHTML('beforeend', html)

    // Keys.refresh()
    refreshTokens()
    this.classList.remove('is-loading')

    // Resize input fields
    Postmark.codeFields()
  })
}

function refreshTokens(): void {
  const tokens = document.querySelectorAll('.js-token')
  const deleteButtons = document.querySelectorAll('.js-token .u-btn-delete')

  if (tokens.length <= 1) {
    // Always need at least one token
    deleteButtons.forEach(hideElement)
  }
  if (tokens.length > 1) {
    deleteButtons.forEach(showElement)
  }
  if (tokens.length >= 3) {
    // Max 3 tokens
    hideElement(document.querySelector('.js-generate-token'))
    showElement(document.querySelector('.js-max-tokens-msg'))
  }
}

domready(function initTokens() {
  refreshTokens()

  document
    .querySelector<HTMLButtonElement>('.js-generate-token')
    ?.addEventListener('click', createToken)
})
